<template>
  <div class="statement boxshadow1">
    <div class="statementbox">
      <div class="left">
        免责声明：本网站提供的所有数据均来源于WTO、WCO、各国商务部、各国工贸部、各国/地区海关等官方渠道，所查询相关信息仅供参考，请以各国海关公布数据为准。
      </div>
      <div class="update" v-if="isShow">数据更新时间: {{ dateInfo }}</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "Statement",
  data() {
    return {
      dateInfo: "",
      isShow: false
    };
  },
  methods: {
    getDates() {
      let data = {
        dataType: "1"
      };
      this.$api.getDate(data, {
        success: response => {
          let data = response.data;
          if (data.code === 200) {
            this.dateInfo = data.data;
          }
        },
        error(error) {}
      });
    }
  },
  mounted() {
    let u = Vue._h.storage.local.get("uinfo");
    this.isShow = !Vue._.isEmpty(u);
    if (!Vue._.isEmpty(u)) {
      this.$nextTick(() => {
        this.getDates();
      });
    }
  }
};
</script>
<style scoped>
.statement {
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
  padding: 10px;

  margin: 30px auto;
 
}
.statement {
  line-height: 30px;
  font-size: 15px;
}
.statementbox {
  position: relative;
}
.left {
  padding-right: 190px;
}
.update {
  width: 185px;
  position: absolute;
  right: 0;
  top: 0;
  display: inline-block;
  color: #1885cb;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/statement.vue